<ng-template #scrollLoadComponent>
  <mat-form-field #anchorElement appearance="outline"
                  [ngClass]="{'with-suffix': withSuffix, 'with-prefix': withPrefix, 'max-width responsive-input': maxWidth, 'no-hint': !withHint, 'small': small}"
                  [floatLabel]="floatLabelValue">
    <mat-label *ngIf="label">{{label | translate}}</mat-label>
    <input matInput #selectInput [(ngModel)]="scrollLoad.object" [ngModelOptions]="{standalone: true}" [placeholder]="getPlaceholder"
           (keyup)="search($event)" (focus)="scrollTo(anchorElement); $event.preventDefault()" (blur)="clearIfEmpty()" [matAutocompletePosition]="autoCompletePosition"
           [matAutocomplete]="object" [disabled]="disabled" [required]="required" autocomplete="off">
    <mat-autocomplete #object="matAutocomplete" (optionSelected)="select($event)" class="select-panel {{panelClass}}"
                      [classList]="'select-panel'" [autoActiveFirstOption]="true" [displayWith]="displaySelection"
                      (appOptionsScroll)="scrollLoadObjects()">
      <mat-option *ngIf="!scrollLoad.hasResults && !hasSelectedObjects && !scrollLoad.loading" [disabled]="true">
        {{ (scrollLoad.filteringValue?.length < minInput ? 'general.api_autocomplete_type_more' : 'general.api_autocomplete_no_results') | translate}}
      </mat-option>
      <ng-container *ngIf="hasSelectedObjects">
        <ng-container *ngFor="let object of selectedObjects">
          <mat-option class="selected-option" *ngIf="isOptionVisible(object)" [value]="object">
            <span [innerHTML]="displayOption(object)"></span>
            <mat-icon class="svg-icon remove-button" [svgIcon]="'close'" (click)="removeObject(object)"></mat-icon>
          </mat-option>
        </ng-container>
      </ng-container>
      <mat-option *ngIf="scrollLoad.loading" [disabled]="true">
        <mat-spinner diameter="16"></mat-spinner>
      </mat-option>
      <ng-container *ngIf="scrollLoad.hasResults">
        <ng-container *ngFor="let object of scrollLoad.objects">
          <mat-option *ngIf="isOptionVisible(object)" [value]="object">
            <span [innerHTML]="displayOption(object)"></span>
          </mat-option>
        </ng-container>
      </ng-container>
    </mat-autocomplete>
    <span matTextSuffix class="selected-amount" *ngIf="hasSelectedObjects">{{this.selectedObjects.length}}</span>
    <button matSuffix mat-icon-button type="button" aria-label="Clear" *ngIf="!disabled && (scrollLoad.object || hasSelectedObjects)" (click)="clear()">
      <mat-icon class="svg-icon" [svgIcon]="'close'"></mat-icon>
    </button>
  </mat-form-field>
</ng-template>
